import { Button, Modal, notification } from "antd";
import { editComplement, RequestComplement } from "api/generated";
import { useClient } from "hooks/useClient";
import { useState } from "react";

interface DeleteComplementProps {
  complement?: RequestComplement;
  onCancel: (reload?: boolean) => void;
}

export default function DeleteComplement({
  complement,
  onCancel,
}: DeleteComplementProps) {
  const [isLoading, setIsLoading] = useState(false);
  const { client } = useClient();

  function deleteComplement() {
    if (complement !== undefined) {
      setIsLoading(true);
      editComplement({
        client,
        body: complement,
      })
        .then(({ data }) => {
          notification.success({
            message: "Complemento eliminado",
            description: `${data}`,
          });
        })
        .finally(() => {
          setIsLoading(false);
          onCancel(true);
        });
    }
  }

  return (
    <div>
      {complement && (
        <Modal
          open={complement !== undefined}
          title="Atención"
          onCancel={() => {
            onCancel();
          }}
          footer={[
            <Button
              className="back-button"
              key="cancel-delete"
              onClick={() => {
                onCancel();
              }}
            >
              Cancelar
            </Button>,
            <Button
              danger
              type="primary"
              key="delete"
              loading={isLoading}
              onClick={() => {
                deleteComplement();
              }}
            >
              Confirmar
            </Button>,
          ]}
        >
          <p>
            ¿Está seguro que desea eliminar este complemento? Una vez realizada
            la acción, la información no podrá ser recuperada.
          </p>
        </Modal>
      )}
    </div>
  );
}
